module.exports = __webpack_public_path__ + "img/private-napolimania-pizza-1.8bfecf18.jpg";